export class Data {
    constructor(_elm) {
        this.elm = _elm;
        this.data = {};
        this.readDataProperties();
    }
    readDataProperties() {
        for (let i = 0; i < this.elm.attributes.length; i++) {
            let attr = this.elm.attributes[i];
            if (/^data-/.test(attr.nodeName)) {
                let key = attr.nodeName.replace(/^data-/, '');
                let value = attr.nodeValue.toString();
                this.data[key] = this.valueToType(value);
            }
        }
    }
    getDataValue(key) {
        this.elm.getAttribute(`data-${key}`);
        return this.data[key];
    }
    setDataValue(key, value) {
        this.elm.setAttribute(`data-${key}`, value);
        this.data[key] = value;
    }
    valueToType(_value) {
        let value;
        if (_value.toLowerCase() === "true") {
            value = true;
        }
        else if (_value.toLowerCase() === "false") {
            value = false;
        }
        else if (this.stringIsValidNumber(_value)) {
            value = Number(_value);
        }
        else if (this.isValidJsonString(_value)) {
            value = JSON.parse(_value);
        }
        else {
            value = _value;
        }
        return value;
    }
    isValidJsonString(jsonString) {
        try {
            JSON.parse(jsonString);
        }
        catch (e) {
            return false;
        }
        return true;
    }
    stringIsValidNumber(str) {
        var number = Number(str);
        if (!isNaN(number)) {
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=Data.js.map